import React, { useState, useEffect } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import AgreementDocumentService from "../../Controller/AgreementDocumentController";
import CreateAgreementDocument from "./CreateAgreementDocument";
import HelpSite from "../../../Common/HelpLink";
import AgreementService from "../../Controller/AgreementController";
function AgreementDocumentPage({ AgreementID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [AgreementDocuemnttList, setAgreementDocument] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentAgreementDocument, setCurrentAgreementDocument] = useState(null);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const fetchAgreementDocument = async () => {
        try {
            const data = await AgreementDocumentService.GetAllAgreementDocuments(redirectCallback, AgreementID);
            setAgreementDocument(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchAgreementDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (AgreementID > 0) {
                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
                if (agreementDetail[0].FK_Issue_ID > 0 || agreementDetail[0].FK_SalesOrder_ID > 0) {
                    SetIsClosed("1");
                }

            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchAgreementDetail();
        if (AgreementID > 0) {
            fetchAgreementDocument();
        }
        else {
            setAgreementDocument([])
        }
    }, [AgreementID]);
    const handleCreateAgreementDocumentClick = () => {
        setCurrentAgreementDocument(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (contact) => {
        setCurrentAgreementDocument(contact);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await AgreementDocumentService.DeleteAgreementDocument(redirectCallback, ID);
                fetchAgreementDocument(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const handleSuccess = () => {
        fetchAgreementDocument();   // Close the modal
        handleCloseModal();
    };
    const getFileExtension = (fileName) => {
        const index = fileName.lastIndexOf('.');
        return index !== -1 ? fileName.substring(index) : '';
    };
    const handleDownload = async (e, docuemnt) => {
        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);
        const customName = `${docuemnt.Name}${ext}`;

        try {

            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Agreement/Document/${docuemnt.FileName}`
            );
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = customName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"} className='btn btn-primary btn-sm' onClick={handleCreateAgreementDocumentClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="table-responsive">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Attached File</th>
                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AgreementDocuemnttList.map((docuemnt) => (
                                    <tr key={docuemnt.DocID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(docuemnt) : undefined}>
                                        <td>{docuemnt.Name}</td>
                                        <td>{docuemnt.Description}</td>

                                        <td>
                                            <a
                                                href="#"
                                                onClick={(e) => handleDownload(e, docuemnt)}
                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                            >
                                                {`${docuemnt.Name}${getFileExtension(docuemnt.FileName)}`}
                                            </a>
                                        </td>
                                        <td style={{ "textAlign": "right" }}>

                                            <button disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"} style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(docuemnt.DocID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateAgreementDocument
                    modalInstance={modalInstance}
                    currentAgreementDocument={currentAgreementDocument}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    AgreementID={AgreementID}
                />
            )}
        </div>
    );
}

export default AgreementDocumentPage;
